// @flow
import parseLatLng from 'mz-utils/parseLatLng'
import buildOnesearchTrip from './searchTrip'

// Types
import type { Trip } from '../../../models/trip'
import type {
  PrebookSearchResponse,
  SearchLocation,
  DetailedLocation,
  PrebookSearchServiceTrip,
} from '../../../api_types'

/**
 * Builder to create a Trip object from response of the prebook search API.
 * @param  {PrebookSearchServiceTrip} trip
 * @param  {PrebookSearchResponse} response
 * @return {Trip}
 */
function prebookSearchTripBuilder(
  trip: PrebookSearchServiceTrip,
  response: PrebookSearchResponse
): Trip {
  const convertLocation = (loc: DetailedLocation): SearchLocation => ({
    address: loc.rail_iata_code || loc.iata_code || loc.full_address || '',
    google_id: loc.place_id || '',
    custom_name: loc.custom_name || '',
    airport_name: (loc.iata_code && loc.formatted_address) || '',
    train_station_name: loc.is_train_station
      ? loc.custom_name || loc.formatted_address || loc.rail_iata_code || ''
      : '',
    is_cruise_port: !!loc.is_cruise_port,
    is_train_station: !!loc.is_train_station,
    full_address: loc.formatted_address || '',
    country: loc.country || '',
    favorite_id: loc.favorite_id,
    favorite_source: loc.favorite_source,
    ...parseLatLng(loc.lat, loc.lng),
  })

  return buildOnesearchTrip(
    {
      id: trip.result_id,
      type: 'prebook',
      tags: trip.tags,
      price: trip.total_price,
      steps: (trip.steps: any),
      loyalty: trip.loyalty,
      return_steps: (trip.return_steps: any),
      flt_support: !!trip.flt_support,
    },
    {
      id: response.search_id,
      results: [],
      pickup_datetime: response.pickup_datetime,
      flight_datetime: response.flight_datetime,
      return_pickup_datetime: response.return_pickup_datetime,
      return_flight_datetime: response.return_flight_datetime,
      created_at: response.created_at,
      expires_at: response.expires_at,
      expires_in: response.expires_in,
      flight_type: response.flight_type,
      poll_id: 0,
      mobile_categories: [],
      sources: ['prebook'],
      more_coming: response.more_coming,
      num_passengers: response.num_passengers,
      start_location: response.start_location
        ? convertLocation(response.start_location)
        : null,
      end_location: response.end_location
        ? convertLocation(response.end_location)
        : null,
      currency: {
        code: response.currency_info.code,
        sign: response.currency_info.prefix_symbol,
      },
    }
  )
}

export default prebookSearchTripBuilder
